// Aparência única das dicas (tooltips) dos gráficos: legível nos temas claro e escuro.
export const tooltipTema = {
    contentStyle: {
        background: 'var(--c-surface)',
        border: '1px solid var(--c-border)',
        borderRadius: 10,
        boxShadow: 'var(--c-shadow)',
        color: 'var(--c-text)',
        padding: '8px 12px',
    },
    labelStyle: { color: 'var(--c-text)', fontWeight: 700, marginBottom: 4 },
    itemStyle: { color: 'var(--c-text)' },
    cursor: { fill: 'rgba(128, 128, 128, 0.14)' },
};
